export const COVERAGE_GROUPS_CONFIG = {
  name: {
    key: "name",
    label: "Nombre",
  },
  type: {
    key: "type",
    label: "Tipo",
  }
};

export const COVERAGE_GROUPS_PHRASE = {
  page: {
    table: {
      title: "Catálogo de Rutas para Cobertura",
      actions: {
        edit: 'Editar',
        delete: 'Eliminar'
      }
    }
  },
  modal: {
    titles: {
      edit: "Modificar Agrupación de Coberturas",
      add: "Agregar Nueva Agrupación de Coberturas",
      delete: "¿Estas seguro de eliminar esta Agrupación de Coberturas?",
    },
    actions: {
      cancel: "Cancelar",
      add: "Agregar",
      delete: "Eliminar",
      save: "Guardar",
    },
  },
  search: {
    messages: {
      noStations: "No se ha seleccionado alguna planta.",
    },
  },
};

export const GROUP_TYPES = [
  { label: 'PORTÁTIL', value: 'PORTATIL' },
  { label: 'ESTACIÓN', value: 'ESTACION' }
];
